import {
  GET_LIST_BANK_TAXES,
  CHANGE_VALUE_INPUT_TAXES,
  SAVE_BANK_TAX,
  GET_INFO_BANK_TAX,
  DELETE_BANK_TAX,
  UPLOAD_IMAGE_BANK_TAX,
  BANK_TAX_DEFAULT
} from '../constants/bank_taxes';

export const bank_taxes = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_LIST_BANK_TAXES : {
         return action.payload;
      }
      
      case CHANGE_VALUE_INPUT_TAXES : {
         return action.payload;
      }

      case SAVE_BANK_TAX : {
         return action.payload;
      }

      case GET_INFO_BANK_TAX : {
         return action.payload;
      }

      case DELETE_BANK_TAX : {
         return action.payload;
      }

      case UPLOAD_IMAGE_BANK_TAX : {
         return action.payload;
      }

      case BANK_TAX_DEFAULT : {
         return action.payload;
      }
 
     default :
     return state;
   }
}


